// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes _1oWdS{0%{background:rgba(0,0,0,0)}to{background:rgba(35,24,21,.8)}}@keyframes _1oWdS{0%{background:rgba(0,0,0,0)}to{background:rgba(35,24,21,.8)}}@-webkit-keyframes _2GwFH{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes _2GwFH{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes _2LRvu{0%{opacity:0}to{opacity:1}}@keyframes _2LRvu{0%{opacity:0}to{opacity:1}}@-webkit-keyframes _3AKWU{0%{-webkit-transform:rotate(90deg) translateX(-.2rem);transform:rotate(90deg) translateX(-.2rem)}to{-webkit-transform:rotate(90deg) translateX(.2rem);transform:rotate(90deg) translateX(.2rem)}}@keyframes _3AKWU{0%{-webkit-transform:rotate(90deg) translateX(-.2rem);transform:rotate(90deg) translateX(-.2rem)}to{-webkit-transform:rotate(90deg) translateX(.2rem);transform:rotate(90deg) translateX(.2rem)}}@-webkit-keyframes _2HIY1{to{stroke-dashoffset:0}}@keyframes _2HIY1{to{stroke-dashoffset:0}}._3jJH5{-webkit-animation:_2LRvu .5s;animation:_2LRvu .5s}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_3jJH5",
	"fadeIn": "_2LRvu",
	"backgroundFrame": "_1oWdS",
	"fadeInFrame": "_2GwFH",
	"scrolldown": "_3AKWU",
	"circleDraw": "_2HIY1"
};
module.exports = exports;
